var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"update"}},[_c('div',{staticClass:"title"},[_vm._v("导入地图")]),_c('input',{attrs:{"type":"file","accept":".json"},on:{"change":_vm.upload}})])
}
var staticRenderFns = []

export { render, staticRenderFns }